import { inject } from '@angular/core';
import { MetaService } from '@core/services/meta.service';
import { IMetaData } from '@core/types/meta';

import { IArticle } from '../interfaces/article.interface';
import { ArticlesDataService } from '../services/articles.data.service';

export const articleResolver: () => void = () => {
  const articlesService: ArticlesDataService = inject(ArticlesDataService);
  const metaService: MetaService = inject(MetaService);
  const { meta, preview }: IArticle = articlesService.article();
  const metaData: IMetaData = {
    name: 'description',
    content: meta.description,
    title: meta.title,
    image: preview.background.image.data?.attributes.url,
  };

  metaService.updateMetaTags(metaData);
};
